export const constructQuestionId = (questionIndex: string, keypointIdList: string[] = []): string => {
  return `${keypointIdList.join("_")}${keypointIdList.length ? "_" : ""}${questionIndex}`;
};

export const extractObjectifArrayFromSkillTesterQuestionId = (questionId: string): string[] => {
  const questionObjectiveArray: string[] = questionId.split("_");
  questionObjectiveArray.pop();
  return questionObjectiveArray;
};
